import { Box, ButtonBase, Typography } from '@mui/material';

import ChevronDownIcon from '../../../../../components/svgs/ChevronDownIcon';
import { FORTA_WHITE } from '../../../../../utils/colors';
import { TP_OPTIONS_MENU_ID } from '../constants';
import {
  TP_OPTIONS_BUTTON_SX,
  TP_OPTIONS_CHEVRON_SEGMENT_SX,
  TP_OPTIONS_LABEL_SEGMENT_SX,
} from '../styles';

import type { TpOptionsButtonProps } from './types';

export default function TpOptionsButton({ disabled, isOpen, onClick }: TpOptionsButtonProps) {
  return (
    <ButtonBase
      data-testid="treatmentPlanActionsDropDown"
      disableRipple
      disabled={disabled}
      aria-haspopup="menu"
      aria-expanded={isOpen}
      aria-controls={isOpen ? TP_OPTIONS_MENU_ID : undefined}
      onClick={onClick}
      sx={TP_OPTIONS_BUTTON_SX}
    >
      <Box sx={TP_OPTIONS_LABEL_SEGMENT_SX}>
        <Typography variant="button" color={FORTA_WHITE}>
          TP options
        </Typography>
      </Box>
      <Box sx={TP_OPTIONS_CHEVRON_SEGMENT_SX}>
        <ChevronDownIcon color={FORTA_WHITE} />
      </Box>
    </ButtonBase>
  );
}
